import Link from 'next/link';

import type { NavbarItems } from '../types';

interface BasicElementsProps {
  items: NavbarItems;
  setMobileMenuOpen: (open: boolean) => void;
}

export function BasicElements(props: BasicElementsProps) {
  const { items, setMobileMenuOpen } = props;

  const basicElements = items.filter(
    (item) => !('group' in item) && item.type === 'basic',
  );

  return (
    <>
      {basicElements.map((item) => (
        <Link
          key={item.name}
          onClick={() => setMobileMenuOpen(false)}
          href={'href' in item ? item.href : '#'}
          target={'blank' in item ? '_blank' : undefined}
          className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-neutral-900 hover:bg-neutral-50"
        >
          {item.name}
        </Link>
      ))}
    </>
  );
}
